import { Injectable } from '@angular/core';
import { BetPayResponse, SaveBetParam } from '../../models/save-bet-options.model';
import { HttpService } from '../helper/http.service';
import { environment } from '../../../environments/environment';
import { EndPoints, TurfEndpoints } from '../../../configs/api.config';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BetslipService {
  
  constructor(private httpService: HttpService) { }

  addPartantToBetslip() {

  }

  saveAnonymousBet(reqBody: Partial<SaveBetParam>) {
    const [gw, api] = [environment.API.turfGateway, TurfEndpoints.saveBetAnnonymous];
    // const [gw, api] = ['http://10.12.1.94:8086/lonani_test_hippique_services', EndPoints.saveBet];
    return this.httpService.getNoAuth<any>(gw, api, reqBody).pipe(
      // map((res: BetPayResponse[]) => res)
    )
  }

  checkStatus(reqBody: Partial<any>) {
    const [gw, api] = [environment.API.turfGateway, TurfEndpoints.checkStatus];
    return this.httpService.getNoAuth<any>(gw, api, reqBody).pipe(
      // map((res: BetPayResponse[]) => res)
    )
  }

}
